<template>
<v-container app :fluid="true" class="pt-0">
    <v-row v-if="cashCurrent != ''">
        <v-col cols="10" class="pt-0" >
            <template>
                <v-row>
                    <v-col cols="12" class="pt-0 pb-0">
                        <Summary></Summary>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pt-0">
                        <Detail></Detail>
                    </v-col>
                </v-row>
            </template>
        </v-col>
        <v-col cols="2" class="pt-0">
            <Actions></Actions>
        </v-col>
    </v-row>
    <v-row v-else justify="center">
        <v-col cols="3" class="pt-0">
            <Actions></Actions>
        </v-col>
    </v-row>
</v-container>    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import Summary from '../../components/Cashflow/Summary'
import Detail from '../../components/Cashflow/Detail'
import Actions from '../../components/Cashflow/Actions'

export default {
    name: 'Cashflow',
    components: {
        Summary,
        Detail,
        Actions
    },
    computed: {
        ...mapState('cash', [
            'dateFilter',
            'cashCurrent'
        ])
    },
    methods: {
        ...mapActions('cash', [
            'getCashCurrent',
            'getTotalAmount',
            'runSetDateFilter',
            'selectCash',
            'getIncomes'
        ]),
        getCurrentDate() {
            let current = new Date();
            let year = current.getFullYear()
            let month = current.getMonth() + 1
            let day = current.getDate()

            if (month < 10) {
                month = '0' + month.toString()
            }

            if (day < 10) {
                day = '0' + day.toString()
            }

            let dateCurrent = year + '-' + month + '-' + day
            this.runSetDateFilter(dateCurrent)
        },
        async loadData () {
            this.getCurrentDate();
            await this.getCashCurrent();
            if (this.cashCurrent) {
                this.selectCash(this.cashCurrent);
                await this.getTotalAmount(this.cashCurrent.id);
            }            
        }
    },
    created () {
        this.loadData();
    }
}
</script>

<style>

</style>